import { render, staticRenderFns } from "./regist-complete.vue?vue&type=template&id=01404e31&scoped=true&"
import script from "./regist-complete.vue?vue&type=script&lang=ts&"
export * from "./regist-complete.vue?vue&type=script&lang=ts&"
import style0 from "./regist-complete.vue?vue&type=style&index=0&id=01404e31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01404e31",
  null
  
)

export default component.exports